<template>
  <v-container grid-list-xl>
      <div class="head-title">
      <h1 class="display-1">Documents</h1>
    </div>
    <v-layout row wrap class="mt-4">
      <v-flex xs12 sm6>
        <v-card>
            <v-list subheader>
              <v-subheader>Français</v-subheader>
              <v-list-item @click="download">
                <v-list-item-icon>
                  <v-icon color="secondary">cloud_download</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <span><a href="https://procommissions.com/files/contrat/CONTRAT%20D'ENTREPRISE%2006%202018.pdf" target="_blank">Contrat d'entreprise</a> </span>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="download">
                <v-list-item-icon>
                  <v-icon color="secondary">cloud_download</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <span><a href="https://procommissions.com/files/contrat/CONTRAT%20D'AGENT%2006%202018.pdf" target="_blank">Contrat de représentant</a> </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="download">
                <v-list-item-icon>
                  <v-icon color="secondary">cloud_download</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <span><a href="https://www.desjardins.com/fr/entreprises/h1/dpa09-fixe-8x14.pdf" target="_blank">Document de prélèvement préautorisé </a></span>
                </v-list-item-content>
              </v-list-item>
            </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6>
        <v-card>
            <v-list subheader>
              <v-subheader>English</v-subheader>
              <v-list-item @click="download">
                <v-list-item-icon>
                  <v-icon color="secondary">cloud_download</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <span> <a href="http://www.procommissions.com/files/BUSINESS_CONTRACT.pdf" target="_blank">Company contract</a> </span>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="download">
                <v-list-item-icon>
                  <v-icon color="secondary">cloud_download</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <span><a href="http://www.procommissions.com/files/SALES_AGENT_CONTRACT.pdf" target="_blank">Representant contract</a></span>
                </v-list-item-content>
              </v-list-item>
            </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
  export default {
    name: 'Documents',
    methods: {
      download () {
      }
    }
  }
</script>

<style scoped>

</style>